import styles from 'css/Box.module.css'
import Lib from 'library'

const Box = ({ className, children, onClick, style }) => {

	const _class = Lib.getStyle(className, styles)

	return (
		<div style={style} className={`${styles.default} ${_class}`} onClick={onClick}>
			{ children }
		</div>
	)
}

export default Box
